import { $authHost } from 'app/configs/axiosConfig';
import {
  AgentDashboardResponse,
  AgentLeadInfo,
  AgentLeads,
  AgentRefName,
  Agents,
  AgentsFilters,
  CreateLeadDocumentUrlResponse,
  LeadDocumentDownloadResponse,
  LeadDocumentsResponse,
  LeadPaymentResponse,
  PaymentParams,
  PostAgent,
  PostAgentLead,
  UpdateAgentLeadsPayments,
} from '../types';

export const inviteAgent = (data: Partial<PostAgent>) => {
  return $authHost.post('/agents/inviteAgent', data);
};

export const getAgents = (params: AgentsFilters) => {
  return $authHost.get<Agents>('/agents', { params });
};

export const getAgentRefName = () => {
  return $authHost.get<AgentRefName>('/agents/refName');
};

export const updateAgent = (id: string, data: Partial<PostAgent>) => {
  return $authHost.patch(`/agents/${id}`, data);
};

export const deleteAgent = (id: string) => {
  return $authHost.delete(`/agents/${id}`);
};
export const deleteAgentLead = (id: number | string) => {
  return $authHost.delete(`/agent-leads/${id}`);
};

export const createAgentLead = (body: PostAgentLead) => {
  return $authHost.post<AgentLeads>(`/agent-leads`, body);
};

export const getAgentLeads = (id: string, leadName?: string) => {
  return $authHost.get<AgentLeads>(`/agents/${id}/leads`, {
    params: {
      leadName,
    },
  });
};

export const getAgentPayments = (params: PaymentParams) => {
  return $authHost.get<LeadPaymentResponse>(`/residual-payments/${params.agentId}/range`, {
    params,
  });
};

export const updateAgentLeadPayments = (data: UpdateAgentLeadsPayments) => {
  return $authHost.post<AgentLeads>(`/residual-payments/update/${data.params.agentId}`, data.body, {
    params: data.params,
  });
};

// export const validateInviteLink = (code: string) => {
//   return $authHost.get<AgentValidateLinkResponse>(`/agent-leads/validate-code/${code}`);
// };

export const saveAgentLead = (body: AgentLeadInfo, code: string) => {
  return $authHost.post(`/agent-leads/referral/${code}`, body);
};

export const uploadAgentDocument = (agentLeadId: number, data) => {
  return $authHost.post(`/agent-leads/${agentLeadId}/attachments`, data);
};

export const getAgentLeadDocuments = (agentLeadId: number) => {
  return $authHost.get<LeadDocumentsResponse>(`/agent-leads/${agentLeadId}/attachments`);
};
export const getAgentDocuments = (agentId: string) => {
  return $authHost.get<LeadDocumentsResponse>(`/agent-leads/agent/${agentId}/attachments`);
};

export const deleteAgentDocuments = (agentLeadId: number, attachmentId: number) => {
  return $authHost.delete(`/agent-leads/${agentLeadId}/attachments/${attachmentId}`);
};

export const downloadAgentDocuments = (agentLeadId: number) => {
  return $authHost.get<LeadDocumentDownloadResponse>(
    `/agent-leads/${agentLeadId}/document/download`,
  );
};

export const downloadAgentAttachment = (agentLeadId: number, attachmentId: number) => {
  return $authHost.get<LeadDocumentDownloadResponse>(
    `/agent-leads/${agentLeadId}/attachments/${attachmentId}/download`,
  );
};

export const createDocumentForAgentLead = (agentLeadId: number) => {
  return $authHost.get<CreateLeadDocumentUrlResponse>(
    `/agents/createDocumentForLead/${agentLeadId}`,
  );
};

export const downloadLeadPayments = (agentId: string, year: number) => {
  return $authHost.get<LeadDocumentDownloadResponse>(`/residual-payments/export/${agentId}`, {
    params: {
      agentId,
      year,
    },
  });
};

import { AdminFilters, FilteredAgents } from 'src/app/types';

export const getFilteredAgents = (filters: AdminFilters) => {
  return $authHost.post<FilteredAgents>(`/agents/filter`, filters);
};

export const getAgentDashboardInfo = (id: string) => {
  return $authHost.get<AgentDashboardResponse>(`/agents/${id}/dashboard`);
};
